import { Howler, Howl } from 'howler';
import eventHub from './eventHub';

const audio = {
  sounds: [
    {
      id: 'background',
      file: '/assets/audio/background.mp3',
      ref: null,
      loop: true,
      volume: 0.2,
    }, {
      id: 'background-walk',
      file: '/assets/audio/background-run.mp3',
      ref: null,
      loop: true,
      volume: 0.09,
    }, {
      id: 'background-intro',
      file: '/assets/audio/background-intro.mp3',
      ref: null,
      loop: true,
      volume: 0.5,
    }, {
      id: 'click',
      file: '/assets/audio/click.mp3',
      ref: null,
      loop: false,
      volume: 0.1,
    }, {
      id: 'flower-pop',
      file: '/assets/audio/flower-pop.mp3',
      ref: null,
      loop: false,
      volume: 0.09,
    }, {
      id: 'branches',
      file: '/assets/audio/branches.mp3',
      ref: null,
      loop: false,
      volume: 0.3,
    }, {
      id: 'powerup-pop',
      file: '/assets/audio/powerup-pop.mp3',
      ref: null,
      loop: false,
      volume: 0.3,
    }, {
      id: 'super-pop',
      file: '/assets/audio/super-pop.mp3',
      ref: null,
      loop: false,
      volume: 0.3,
    }, {
      id: 'char-swipe',
      file: '/assets/audio/char-swipe.mp3',
      ref: null,
      loop: false,
      volume: 0.3,
    }, {
      id: 'gameover',
      file: '/assets/audio/gameover.mp3',
      ref: null,
      loop: false,
      volume: 1,
    }, {
      id: 'blowall',
      file: '/assets/audio/blowall.mp3',
      ref: null,
      loop: false,
      volume: 0.05,
    },
  ],

  init() {
    audio.sounds.forEach((s) => {
      s.ref = new Howl({ src: [s.file], loop: s.loop, volume: s.volume });
      s.promise = () => new Promise((resolve) => s.ref.once('load', resolve));
    });

    eventHub.$on('playGeneralAudio', audio.unmute);
    eventHub.$on('pauseGeneralAudio', audio.mute);
  },

  load() {
    return new Promise((resolve) => {
      const promises = [];
      audio.sounds.forEach((s) => promises.push(s.promise()));

      Promise.all(promises).then(resolve);
    });
  },

  get(id) {
    return audio.sounds.find((s) => s.id === id).ref;
  },

  play(id) {
    audio.get(id).play();
  },

  stop(id) {
    audio.get(id).pause();
  },

  mute() {
    Howler.mute(true);
  },

  unmute() {
    Howler.mute(false);
  },
};

export default audio;
